// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cargo-form-dialog .el-dialog__header, .cargo-form-dialog .el-dialog__body, .cargo-form-dialog .el-dialog__footer {\n  padding: 10px 15px !important;\n}\n.cargo-form-dialog .el-dialog__title {\n  vertical-align: middle;\n}\n.cargo-form-dialog .el-dialog__headerbtn {\n  top: 15px;\n  right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
